import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiHooks from '../../../hooks/apiHooks';
import ListDataPage from '../../../components/pages/ListDataPage';
import dayjs from 'dayjs';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import ActionDropdownItems from 'components/common/ActionDropdownItems';

interface ActionItem {
  eventKey: string;
  label: string;
  type: 'function' | 'redirect'; // Ensure type is restricted
  callback?: () => void;
  url?: string;
  className?: string;
  divider?: boolean;
}

const AllProducts = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to return properly typed actions for each row
  const getActions = (product_id: string): ActionItem[] => [
    {
      eventKey: '2',
      label: 'Edit',
      type: 'function',
      callback: () => navigate(`/inventory/products/edit-product/${product_id}`)
    },
    {
      eventKey: '3',
      label: 'Remove',
      type: 'function',
      // callback: () => deleteSalesService(service_id),
      className: 'text-danger'
    },
    {
      eventKey: '3',
      label: 'Add Stock',
      type: 'function',
      callback: () => navigate(`/inventory/products/add-stock/${product_id}`)
    }
  ];

  const columns = [
    { accessorKey: 'product_id', header: 'Product ID' },
    { accessorKey: 'product_name', header: 'Product Name' },
    { accessorKey: 'category', header: 'Category' },
    { accessorKey: 'stock_quantity', header: 'Stock' },
    { accessorKey: 'CDC_FLAG', header: 'Status' },
    {
      accessorKey: 'created_at',
      header: 'Created At',
      cell: ({ row }: { row: any }) => (
        <span>
          {dayjs(row.original.created_at).format('DD/MM/YYYY HH:mm:ss')}
        </span>
      )
    },
    {
      id: 'action',
      header: 'Actions',
      cell: ({ row }: { row: any }) => (
        <RevealDropdownTrigger style={{ zIndex: '999' }}>
          <RevealDropdown>
            <ActionDropdownItems
              actions={getActions(row.original.product_id)}
            />
          </RevealDropdown>
        </RevealDropdownTrigger>
      ),
      meta: {
        headerProps: { style: { width: '7%' } },
        cellProps: { className: 'text-center' }
      }
    }
  ];

  return (
    <ListDataPage
      apiHook={apiHooks.useInventoryProducts}
      entityName="All Products"
      columns={columns}
    />
  );
};

export default AllProducts;
